// src/context/CartContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNotification } from "./notificationContext";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [, , showNotification] = useNotification();

  const [localCart, setLocalCart] = useState([]);
  const [cartShow, setCartShow] = useState(false); // ✅ New state for cart visibility

  // Load cart from localStorage on mount
  useEffect(() => {
    const savedCart = localStorage.getItem("guestCart");
    if (savedCart && savedCart !== "undefined") {
      const parsed = JSON.parse(savedCart);
      if (Array.isArray(parsed)) {
        setLocalCart(parsed);
      }
    }
  }, []);

  // Save cart to localStorage when localCart changes
  useEffect(() => {
    localStorage.setItem("guestCart", JSON.stringify(localCart));
  }, [localCart]);

  // Add item to cart
  const addToCart = ({ productId, name, image, size, price, quantity = 1 }) => {
    const existing = localCart.find(
      (item) => item.productId === productId && item.size === size
    );

    if (existing) {
      showNotification("warning", "Item already in cart");
    } else {
      const updatedCart = [
        ...localCart,
        { productId, name, image, size, price, quantity },
      ];
      setLocalCart(updatedCart);
      showNotification("success", "Item added to cart");
      setCartShow(true);
    }
  };

  // Remove item from cart
  const removeFromCart = (productId, size) => {
    const updatedCart = localCart.filter(
      (item) => !(item.productId === productId && item.size === size)
    );
    setLocalCart(updatedCart);
    showNotification("error", "Item removed from cart");
  };

  // Update quantity
  const updateQuantity = (productId, size, newQuantity) => {
    if (newQuantity <= 0) return;

    const updatedCart = localCart.map((item) =>
      item.productId === productId && item.size === size
        ? { ...item, quantity: newQuantity }
        : item
    );
    setLocalCart(updatedCart);
  };

  // Check if item exists
  const isItemInCart = (productId, size) =>
    localCart.some(
      (item) => item.productId === productId && item.size === size
    );

  const clearCart = () => {
    setLocalCart([]);
    localStorage.removeItem("guestCart");
  };

  return (
    <CartContext.Provider
      value={{
        cartList: localCart,
        addToCart,
        removeFromCart,
        updateQuantity,
        isItemInCart,
        clearCart,
        cartShow,      
        setCartShow,    
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
